import { Grid } from "@mui/material";
import { useEffect, useState } from "react";
import ByzMuiMultiSelect, { SelectOption } from "../../mui/ByzMuiMultiSelect";
import { useTranslate } from "src/locales";
import { referenceService } from "src/api/references/referenceService";

interface Props {
  value: SelectOption[];
  onChange: (v: SelectOption[]) => void;
  all?: boolean;
}

export default function ComingTypeFilter({ value, onChange, all = false }: Props) {
  const { t } = useTranslate();
  const [options, setOptions] = useState<SelectOption[]>([]);

  useEffect(() => {
    let isMounted = true;

    const fetchPatientTypes = async () => {
      try {
        console.log("ComingTypeFilter: Fetching patient types, all:", all);
        const response = await referenceService.patientTypes.getPatientTypes(
          all ? { all: true } : undefined
        );

        console.log("ComingTypeFilter: Response received", response);

        if (!isMounted) return;

        if (response?.issuccess && response.data) {
          const mappedOptions = response.data.map((item) => ({
            label: item.name,
            value: String(item.id),
          }));
          console.log("ComingTypeFilter: Setting options", mappedOptions);
          setOptions(mappedOptions);
        } else {
          console.warn("ComingTypeFilter: Invalid response", response);
          setOptions([]);
        }
      } catch (error) {
        if (isMounted) {
          setOptions([]);
        }
        console.error("Error loading patient types:", error);
      }
    };

    fetchPatientTypes();

    return () => {
      isMounted = false;
    };
  }, [all]);

  return (
    <Grid item xs={12} sm={6} md={2}>
      <ByzMuiMultiSelect
        label={t("coming-type")}
        options={options}
        value={value}
        onChange={onChange}
        minWidth="100%"
      />
    </Grid>
  );
}
